import React, { useEffect } from "react"
import { Box, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { CreditCard } from "@material-ui/icons"
import { useSnackbar } from "../../utils/notificacoes"
import Cabecalho from "../Cabecalho"
import { FiltrosCartelas } from "./components/FiltrosCartelas"
import { TabelaCartelas } from "./components/TabelaCartelas"
import { useCartelasFornecedorContext } from "./context/useCartelasFornecedorContext"

const useStyles = makeStyles(theme => ({
    container: {
        paddingLeft: "90px",
        paddingRight: "10px",
        paddingTop: "100px",
        paddingBottom: "30px",
        [theme.breakpoints.down("md")]: { paddingLeft: "20px", paddingRight: "20px", paddingTop: "80px" },
        [theme.breakpoints.down("sm")]: { paddingLeft: "15px", paddingRight: "15px", paddingTop: "70px" },
    },
    content: {
        margin: "auto",
        maxWidth: "1200px",
        [theme.breakpoints.down("sm")]: { maxWidth: "100%" },
    },
    titleRow: {
        display: "flex",
        alignItems: "center",
        marginBottom: theme.spacing(1),
    },
    iconHeader: {
        color: "#4caf50",
        marginRight: theme.spacing(1),
        fontSize: "2rem",
    },
    titleText: {
        fontWeight: 600,
        color: "#2c3e50",
        [theme.breakpoints.down("sm")]: { fontSize: "1.5rem" },
        [theme.breakpoints.down("xs")]: { fontSize: "1.25rem" },
    },
    subtitleText: {
        color: "#7f8c8d",
        marginBottom: theme.spacing(3),
    },
}))

export function CartelasFornecedor() {
    const classes = useStyles()
    const { erroCarregamento } = useCartelasFornecedorContext()
    const { enqueueSnackbar } = useSnackbar()

    useEffect(() => {
        if (erroCarregamento) {
            enqueueSnackbar(erroCarregamento, { variant: "error" })
        }
    }, [erroCarregamento])

    return (
        <>
            <Cabecalho pagina="Cartelas" />
            <Box className={classes.container}>
                <Box className={classes.content}>
                    <Box className={classes.titleRow}>
                        <CreditCard className={classes.iconHeader} />
                        <Typography variant="h5" className={classes.titleText}>
                            Cartelas dos Clientes
                        </Typography>
                    </Box>
                    <Typography variant="body2" className={classes.subtitleText}>
                        Verifique todas as cartelas de fidelidade criadas pelo seu estabelecimento.
                    </Typography>

                    <FiltrosCartelas />
                    <TabelaCartelas />
                </Box>
            </Box>
        </>
    )
}
